import { render, staticRenderFns } from "./SchemaListItem.vue?vue&type=template&id=ecccd63c"
import script from "./SchemaListItem.vue?vue&type=script&lang=js"
export * from "./SchemaListItem.vue?vue&type=script&lang=js"
import style0 from "./SchemaListItem.vue?vue&type=style&index=0&id=ecccd63c&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports